// Drop function for saved Widgets


export const tempHandleDeviceDrop = (e, data, index, id, x, y, deviceType, state) => {
    const {
        tempImages,
        updatedImages,
        activeTabIndex,
        setTempImages,
        setUpdatedImages,
        setClickedDeviceIndex,
        setSelectedDevice,
        setIndexesOfDevicePosi,
        tempTabIndexDevices,
        tempTabIndexDisplay,
        tempTabIndexController,
        tempTabIndexIO,
        tempTabIndexFlowM,
        tempTabIndexEnergyM,
        tempTabIndexText,
        tempTabIndexMotor,
        updatedTabIndexLineChart,
        tempTabIndexPieChart,
        tempTabIndexBarChart,
        tempTabIndexHistogram,
        tempTabIndexGauge,
        tempTabIndexProgress,
        tempTabIndexGrid,
        tempTabIndexTable,
        setUpdatedTabIndexDevices,
        setUpdatedTabIndexDisplay,
        setUpdatedTabIndexController,
        setUpdatedTabIndexIO,
        setUpdatedTabIndexFlowM,
        setUpdatedTabIndexEnergyM,
        setUpdatedTabIndexText,
        setUpdatedTabIndexMotor,
        setUpdatedTabIndexLineChart,
        setUpdatedTabIndexPieChart,
        setUpdatedTabIndexBarChart,
        setUpdatedTabIndexHistogram,
        setUpdatedTabIndexGauge,
        setUpdatedTabIndexProgress,
        setUpdatedTabIndexGrid,
        setUpdatedTabIndexTable,
        tempTabIndexDoughnut,
        setUpdatedTabIndexDoughnut,
        tempTabIndexCircularProgress,
        setUpdatedTabIndexCircularProgress,
        tempTabIndexSquare,
        setUpdatedTabIndexSquare,
        tempTabIndexCircle,
        setUpdatedTabIndexCircle,
        tempTabIndexPolygone,
        setUpdatedTabIndexPolygone,
        tempTabIndexPipe,
        setUpdatedTabIndexPipe,
        tempTabIndexSwitch,
        setUpdatedTabIndexSwitch,
        tempTabIndexCheckbox,
        setUpdatedTabIndexCheckbox,
        tempTabIndexRadio,
        setUpdatedTabIndexRadio,
        tempTabIndexSlider,
        setUpdatedTabIndexSlider,
        tempTabIndexLamp,
        setUpdatedTabIndexLamp,
        tempTabIndexPush,
        setUpdatedTabIndexPush,
        tempTabIndexLink,
        setUpdatedTabIndexLink,
        tempTabIndexClock,
        setUpdatedTabIndexClock,
        tempTabIndexLines,
        setUpdatedTabIndexLines,


    } = state;

    const deviceTabIndexMap = {
        Indicator: { state: tempTabIndexDevices, setter: setUpdatedTabIndexDevices },
        Display: { state: tempTabIndexDisplay, setter: setUpdatedTabIndexDisplay },
        Controller: { state: tempTabIndexController, setter: setUpdatedTabIndexController },
        DigitalIO: { state: tempTabIndexIO, setter: setUpdatedTabIndexIO },
        FlowMeter: { state: tempTabIndexFlowM, setter: setUpdatedTabIndexFlowM },
        EnergyMeter: { state: tempTabIndexEnergyM, setter: setUpdatedTabIndexEnergyM },
        Text: { state: tempTabIndexText, setter: setUpdatedTabIndexText },
        Motor: { state: tempTabIndexMotor, setter: setUpdatedTabIndexMotor },
        LineChart: { state: updatedTabIndexLineChart, setter: setUpdatedTabIndexLineChart },
        PieChart: { state: tempTabIndexPieChart, setter: setUpdatedTabIndexPieChart },
        BarChart: { state: tempTabIndexBarChart, setter: setUpdatedTabIndexBarChart },
        Histogram: { state: tempTabIndexHistogram, setter: setUpdatedTabIndexHistogram },
        Gauge: { state: tempTabIndexGauge, setter: setUpdatedTabIndexGauge },
        Progress: { state: tempTabIndexProgress, setter: setUpdatedTabIndexProgress },
        Grid: { state: tempTabIndexGrid, setter: setUpdatedTabIndexGrid },
        Table: { state: tempTabIndexTable, setter: setUpdatedTabIndexTable },
        CircularProgress: { state: tempTabIndexCircularProgress, setter: setUpdatedTabIndexCircularProgress },
        Doughnut: { state: tempTabIndexDoughnut, setter: setUpdatedTabIndexDoughnut },
        Square: { state: tempTabIndexSquare, setter: setUpdatedTabIndexSquare },
        Circle: { state: tempTabIndexCircle, setter: setUpdatedTabIndexCircle },
        Polygone: { state: tempTabIndexPolygone, setter: setUpdatedTabIndexPolygone },
        Pipe: { state: tempTabIndexPipe, setter: setUpdatedTabIndexPipe },
        Switch: { state: tempTabIndexSwitch, setter: setUpdatedTabIndexSwitch },
        Checkbox: { state: tempTabIndexCheckbox, setter: setUpdatedTabIndexCheckbox },
        Radio: { state: tempTabIndexRadio, setter: setUpdatedTabIndexRadio },
        Slider: { state: tempTabIndexSlider, setter: setUpdatedTabIndexSlider },
        Lamp: { state: tempTabIndexLamp, setter: setUpdatedTabIndexLamp },
        Push: { state: tempTabIndexPush, setter: setUpdatedTabIndexPush },
        Link: { state: tempTabIndexLink, setter: setUpdatedTabIndexLink },
        Clock: { state: tempTabIndexClock, setter: setUpdatedTabIndexClock },
        Line: { state: tempTabIndexLines, setter: setUpdatedTabIndexLines },

    };

    // Update clicked device and selection
    setClickedDeviceIndex(index);
    setSelectedDevice(id);
    setIndexesOfDevicePosi((prev) => [...prev, index]);

    // Update images array
    const updatePosition = (arr) => {
        if (deviceType !== "Push") {
            return arr.map((d) => (d.id === id ? { ...d, x: x + data.x, y: y + data.y } : d));
        } else {
            return arr.map((d) => (d.id === id ? { ...d, x: x + data.x, y: y + data.y, on: 0 } : d));

        }
    };


    setTempImages(updatePosition(tempImages));
    setUpdatedImages(updatePosition(updatedImages));

    // Update the correct device state dynamically
    if (deviceTabIndexMap[deviceType]) {
        const { state: deviceState, setter: setDeviceState } = deviceTabIndexMap[deviceType];
        if (deviceState[activeTabIndex]) {
            setDeviceState({
                [activeTabIndex]: updatePosition(deviceState[activeTabIndex]),
            });
        }
    }
};

// Drop function for new Widget

export const handleDeviceDrop = (e, data, deviceIndex, deviceType, stateSetters) => {
    const {
        setDevicePosition,
        setDisplayPosition,
        setControllerPosition,
        setIOPosition,
        setFlowMPosition,
        setEnergyMPosition,
        setMotorPosition,
        setTextPosition,
        setLineChartPosition,
        setPieChartPosition,
        setBarChartPosition,
        setHistogramPosition,
        setGaugePosition,
        setProgressPosition,
        setGridPosition,
        setTablePosition,
        setCircularProgressPosition,
        setDoughnutPosition,
        setSquarePosition,
        setCirclePosition,
        setPolygonePosition,
        setSwitchPosition,
        setCheckboxPosition,
        setRadioPosition,
        setSliderPosition,
        setLampPosition,
        setPipePosition,
        setPushPosition,
        setLinkPosition,
        setClockPosition,
        setLinePosition,
        pipe,
        line
    } = stateSetters;

    // Mapping device types to their respective state setters
    const positionSetters = {
        Indicator: setDevicePosition,
        Display: setDisplayPosition,
        Controller: setControllerPosition,
        DigitalIO: setIOPosition,
        FlowMeter: setFlowMPosition,
        EnergyMeter: setEnergyMPosition,
        Motor: setMotorPosition,
        Text: setTextPosition,
        LineChart: setLineChartPosition,
        PieChart: setPieChartPosition,
        BarChart: setBarChartPosition,
        Histogram: setHistogramPosition,
        Gauge: setGaugePosition,
        ProgressBar: setProgressPosition,
        Grid: setGridPosition,
        Table: setTablePosition,
        CircularProgress: setCircularProgressPosition,
        Doughnut: setDoughnutPosition,
        Square: setSquarePosition,
        Circle: setCirclePosition,
        Polygone: setPolygonePosition,
        Switch: setSwitchPosition,
        Checkbox: setCheckboxPosition,
        Radio: setRadioPosition,
        Slider: setSliderPosition,
        Lamp: setLampPosition,
        Push: setPushPosition,
        Link: setLinkPosition,
        Clock: setClockPosition,
        Line: setLinePosition,
        Pipe: { setPipePosition, pipe }
    };

    // Get the appropriate setter function
    const setPosition = positionSetters[deviceType];
    if (setPosition) {
        if (deviceType !== "Pipe") {

            const newPosition = { x: data.x, y: data.y };
            setPosition((prevPositions) => {
                const newPositions = [...prevPositions]; // Copy previous state
                newPositions[deviceIndex] = newPosition; // Update the specific index
                return newPositions;
            });

        } else if (deviceType === "Pipe") {
            const newPosition = { x: setPosition.pipe.x + data.x, y: setPosition.pipe.y + data.y };
            setPosition.setPipePosition((prevPositions) => {
                const newPositions = [...prevPositions]; // Copy previous state
                newPositions[deviceIndex] = newPosition; // Update the specific index
                return newPositions;
            });
        }
    }
};
